"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CharacterCount = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _base = _interopRequireDefault(require("../../../style/themes/base"));

var _characterCount = _interopRequireDefault(require("./character-count.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const CharacterCount = ({
  value,
  limit,
  theme,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_characterCount.default, _extends({
  theme: theme
}, props), value, "/", limit);

exports.CharacterCount = CharacterCount;
CharacterCount.propTypes = {
  value: _propTypes.default.string.isRequired,
  limit: _propTypes.default.string.isRequired,
  theme: _propTypes.default.object
};
CharacterCount.defaultProps = {
  theme: _base.default
};

var _default = (0, _styledComponents.withTheme)(CharacterCount);

exports.default = _default;